<template>
  <div class="parent" :style="{ backgroundColor: bgColor }">
    <div class="divContainer">
      <subject-flow-widge
        subject="人工智能"
        :project="name"
        :routerLink="routerLink"
      ></subject-flow-widge>
      <img src="./../img/subjectLogo.png" class="imgSubject" />
      <div class="divContent">
        <div class="divC">
          <img v-lazy="nameImg" class="imgName" />
          <div class="divDesc">{{ desc }}</div>
          <pre-publish-widge :data="date" color="rgba(0, 0, 0, 1)"  bgColor="rgba(9, 227, 241, 1)"></pre-publish-widge>
        </div>
      </div>
      <div class="divProject">
        <div class="divIndustry">
          <div class="divIndustryContainer">
            <img class="divImg" :src="logo" />
            <span class="spanDesc">{{ logoDesc }}</span>
          </div>
        </div>
        <div class="divNum">
          <ul>
            <li v-for="(item, index) in itemList" :key="index">
              <p class="pNum">
                {{ item.num }} <em>{{ item.unit }}</em>
              </p>

              <p class="pDesc">{{ item.type }}</p>
            </li>
          </ul>
        </div>
        <div class="divVideo" @click="handleVideo(video)" v-if="video">
          <div class="divBox"></div>
          <div class="divTriangle">
            <img src="../img/video.png" />
          </div>
          <div class="videoDesc">项目介绍</div>
        </div>
      </div>
    </div>
    <MenuAdd ref="editMenu"></MenuAdd>
  </div>
</template>

<script>
import MenuAdd from "./../../../../components/video";
import subjectFlowWidge from "./../../../../components/subjectFlowWidge";
import prePublishWidge from './../../common/components/prePublishWidge'
export default {
  components: {
    MenuAdd,
    subjectFlowWidge,
    prePublishWidge
  },
  props: {
    name: {
      type: String,
      default: "",
    },
    date: {
      type: String,
      default: "",
    },
    desc: {
      type: String,
      default: "",
    },
    logo: {
      type: String,
      default: "",
    },
    logoDesc: {
      type: String,
      default: "",
    },
    itemList: {
      type: Array,
      default: () => {},
    },
    video: {
      type: String,
      default: "",
    },
    bgColor: {
      type: String,
      default: "rgba(2,27,77,1)",
    },
    nameImg: {
      type: String,
      default: "",
    },
    industryBg: {
      type: String,
      default: "img/ai/industryBg.png",
    },
  },
  computed: {
    routerLink() {
      return {
        path: "/ai"
      };
    },
  },
  methods: {
    handleVideo(url) {
      this.$trackEvent("视频介绍", "点击")
      let obj = {
        url: url,
      };
      this.$refs.editMenu.dialogFormV(obj);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/headFirstWidget.scss";
</style>
